// @generated by scripts/generate-graphql-cache-entity-resolver-schema.ts — do not edit.

export const entityResolverSchema = {
  CompleteMutationRoot: {
    markEmailThreadSeen: {
      targets: ['GraphqlSoupEmailThread'],
      argumentPaths: [['input', 'threadId']],
    },
    markEmailThreadUnread: {
      targets: ['GraphqlSoupEmailThread'],
      argumentPaths: [['input', 'threadId']],
    },
    recordChannelActivity: {
      targets: ['GraphqlChannelActivity'],
      argumentPaths: [['input', 'channelId']],
    },
    setEmailThreadArchived: {
      targets: ['GraphqlSoupEmailThread'],
      argumentPaths: [['input', 'threadId']],
    },
    setEntityProperty: {
      targets: ['GraphqlProperty'],
      argumentPaths: [
        ['input', 'propertyDefinitionId'],
        ['input', 'value', 'entityReference', 'specificMessageId'],
        ['input', 'value', 'selectOption'],
      ],
    },
    updateEmailThreadLabel: {
      targets: ['GraphqlSoupEmailThread'],
      argumentPaths: [
        ['input', 'labelId'],
        ['input', 'threadId'],
      ],
    },
    updateInitiative: {
      targets: ['GraphqlSoupInitiative'],
      argumentPaths: [['initiativeId']],
    },
  },
  GraphqlUser: {
    agentSession: {
      targets: ['GraphqlSoupAgentSession'],
      argumentPaths: [['sessionId']],
    },
    emailThread: {
      targets: ['GraphqlSoupEmailThread'],
      argumentPaths: [['input', 'threadId']],
    },
    initiative: {
      targets: ['GraphqlSoupInitiative'],
      argumentPaths: [['initiativeId']],
    },
  },
} as const;

export type GeneratedEntityResolverSchema = typeof entityResolverSchema;
export type GeneratedEntityResolverTarget =
  | 'GraphqlChannelActivity'
  | 'GraphqlProperty'
  | 'GraphqlSoupAgentSession'
  | 'GraphqlSoupEmailThread'
  | 'GraphqlSoupInitiative';
export type GeneratedEntityResolverArgumentPath =
  | readonly ['initiativeId']
  | readonly ['input', 'channelId']
  | readonly ['input', 'labelId']
  | readonly ['input', 'propertyDefinitionId']
  | readonly ['input', 'threadId']
  | readonly ['input', 'value', 'entityReference', 'specificMessageId']
  | readonly ['input', 'value', 'selectOption']
  | readonly ['sessionId'];
